<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "MainPage",
  data() {
    return {
      title: "home page",
      queryTag: this.$route.query.tag,
      queryFundraiser: this.$route.query.fundraiser,
       
     
     

    };
  },
  methods: {    
    addQueryString(params) {
    history.pushState(
    {},
    null,
    this.$route.path +
      '?' +
      Object.keys(params)
        .map(key => {
          if(params[key] != undefined){
          return (
            encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
          )}
        })
        .join('&')
      )

    },
  },
  watch: {
    $route() {
      if(this.queryTag != undefined || this.queryFundraiser!= undefined  )
      this.addQueryString({fundraiser: this.queryFundraiser, tag: this.queryTag} );
    },
  },
};
</script>
